import { BehaviorSubject } from 'rxjs';
import { constants } from 'src/ajs-app/app.constants.js';

/**
 * Helper service that links between the angularJS and Angular apps.
 *
 * This service cannot have downgraded angular injectables as dependencies,
 * because the angularJS injector creates it before the angular app has been bootstrapped.
 *
 * Note that even though it is an angularJS service, it is implemented in typescript (just because we now can)
 */
export class AngularMigrationHelperService {
  ajsJWT$ = new BehaviorSubject<string>(null);

  constructor(private $urlRouter) {}

  startAngularJSRouter() {
    this.$urlRouter.listen();
    this.$urlRouter.sync();
  }

  processTaskURL(companyId: number, taskId: number) {
    return `${constants.frontendBaseUrl}#/${companyId}/inbox/task/${taskId}?acquire=any`;
  }
}

AngularMigrationHelperFactory.$inject = ['$urlRouter'];
export function AngularMigrationHelperFactory($urlRouter) {
  return new AngularMigrationHelperService($urlRouter);
}
